import type { QuoteFormError } from 'state/addonForm/addonForm.selector';

import type { StaticFormState } from '../staticForm.model';
import type { StaticFormInfos } from './infos.model';

export function getFormInfos(state: StaticFormState, tabId: string): StaticFormInfos | undefined {
  return state.infos[tabId];
}

export function getTabIdsByQuoteId(state: StaticFormState, quoteId: string): string[] {
  const tabIds = [];

  for (const tabId in state.infos) {
    const info = state.infos[tabId];
    if (quoteId === info.quoteId) {
      tabIds.push(tabId);
    }
  }

  return tabIds;
}

const emptyErrors: readonly [] = [];

export function getFormValidationErrors(state: StaticFormState, tabId: string): readonly QuoteFormError[] {
  return getFormInfos(state, tabId)?.validationErrors ?? emptyErrors;
}

export function getFormQuoteId(state: StaticFormState, tabId: string): string | undefined {
  const infos = getFormInfos(state, tabId);
  return infos ? infos.quoteId : undefined;
}

export function getStaticFormIsEnrichmentError(state: StaticFormState, tabId: string): boolean {
  const infos = getFormInfos(state, tabId);
  return infos?.enrichmentError !== undefined;
}
